<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-4" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-text-field
                  label="Siųsto pranešimo registracijos numeris"
                  v-model="extraData.zus_numeris"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Identifikavimo kodas (IDK)"
                  v-model="extraData.zus_identifikavimo_kodas"
                  idk
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Gauto dokumento registracijos numeris"
                  v-model="extraData.zug_numeris"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="objektasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="false"
                  label="Objektas"
                  v-model="extraData.objektas"
                  @change="objektasChange()"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="veiksmasList"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Veiksmas"
                  :readonly="!enableVeiksmas"
                  v-model="extraData.veiksmas"
                  @change="veiksmasChange()"
                />
              </v-col>
              <v-col cols="12" md="12">
                <el-autocomplete
                  :items="zurnalas_siunciami_rusys"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Siųsto pranešimo rūšis"
                  v-model="extraData.zus_dokumento_rusis_kla_id"
                />
              </v-col>

              <v-col cols="12" md="4">
                <el-date-picker
                  label="Būsenos data nuo"
                  v-model="extraData.zus_busenos_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-date-picker
                  label="Būsenos data iki"
                  v-model="extraData.zus_busenos_data_iki"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="busena_siunciamas"
                  itemvalue="value"
                  itemtext="text"
                  :multiple="true"
                  label="Būsena"
                  v-model="extraData.zus_busena"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Adresato pavadinimas"
                  v-model="extraData.zus_adresatas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Adresato el. paštas"
                  v-model="extraData.zus_adresato_el_pastas"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  :loading="loading"
                  primary
                  @click.native.stop="searchData()"
                >
                  Ieškoti
                </el-button>
                <el-button :loading="loading" @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import objektasSearch from '../../mixins/objektasSearch'

export default {
  name: 'ZurnalasSiunciamiSearch',
  props: {
    loading: Boolean,
  },
  mixins: [objektasSearch],
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {
      objektas: null,
      veiksmas: [],
    },
    zurnalas_siunciami_rusys: [],
    busena_siunciamas: [],
  }),
  computed: {
    ...mapGetters(['searchParams', 'listInfo']),
    isExpanded() {
      return this.searchPanel === 0
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: ['zurnalas_siunciami_rusys', 'busena_siunciamas'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.zurnalas_siunciami_rusys = res.data.list.zurnalas_siunciami_rusys
          this.busena_siunciamas = res.data.list.busena_siunciamas

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.checkGautasPranesimas()

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      if (this.$route.params.toList) {
        searchData = this.listInfo.search
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {
        objektas: null,
        veiksmas: [],
      }
    },
    submit() {
      this.searchData()
    },
    clearRusis() {
      //
    },
    checkGautasPranesimas() {
      const gautasPranesimas = sessionStorage.getItem('gautasPranesimas')
      if (gautasPranesimas && gautasPranesimas.length > 0) {
        this.extraData.zus_numeris = gautasPranesimas
        this.searchPanel = 0
      }
      sessionStorage.setItem('gautasPranesimas', '')
    },
  },
}
</script>
